import type { PostgrestError } from "@supabase/supabase-js";

export class ValidationError extends Error {
  constructor(message: string, cause: unknown) {
    super(message, { cause });
    this.name = "ValidationError";
  }
}

export class NotFoundError extends Error {
  constructor(resource: string, id: string) {
    super(`${resource} not found: ${id}`);
    this.name = "NotFoundError";
  }
}

/** Wraps a PostgrestError so callers' `err instanceof Error` checks still work
 * while preserving `.code` / `.details` / `.hint` for debugging. */
export class DbError extends Error {
  code?: string;
  details?: string | null;
  hint?: string | null;
  constructor(pg: PostgrestError) {
    const parts = [pg.message];
    if (pg.details) parts.push(pg.details);
    if (pg.hint) parts.push(`hint: ${pg.hint}`);
    super(parts.filter(Boolean).join(" — "));
    this.name = "DbError";
    this.code = pg.code ?? undefined;
    this.details = pg.details ?? null;
    this.hint = pg.hint ?? null;
  }
}

/** Throws a real Error subclass when Supabase returns a PostgrestError. */
export function throwIfPgError(error: PostgrestError | null): void {
  if (error) throw new DbError(error);
}
